import { useContext } from "react";
import { GlobalAlertContext } from "../../../contexts/GlobalAlertContext";
import SwitchConfig from "../switch";
import { api } from "../../../services/api";

export default function SwitchUser({value, row, handleStatusParent, ...props}){
    const { handleToast, handleLoading, handleConfirmation } = useContext(GlobalAlertContext);
    
    const handleStatus = async () => {
      handleLoading(true);
      try {
        const { data } = await api({
          method: "put",
          url: "/user/" + row?.id,
          data: {
            status: !value ? 1 : 0
          },
        });
        handleToast(true, data.toast, data.message);
        handleStatusParent()
      } catch (err) {
        handleToast(true, err.response.data.toast, err.response.data.message);
      }
      handleLoading(false);
    };
    return(
        <SwitchConfig checked={value} onClick={() => handleConfirmation(true, `Tem certeza que deseja ${!value ? "ativar" : "inativar"} esse usuário ?`, handleStatus, !value ? "Ativar" : "Inativar")} {...props}>

        </SwitchConfig>
    )
}